/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VariantType
 */
export interface VariantType {
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    longTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof VariantType
     */
    view?: string;
    /**
     * 
     * @type {number}
     * @memberof VariantType
     */
    index?: number;
}

/**
 * Check if a given object implements the VariantType interface.
 */
export function instanceOfVariantType(value: object): boolean {
    return true;
}

export function VariantTypeFromJSON(json: any): VariantType {
    return VariantTypeFromJSONTyped(json, false);
}

export function VariantTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariantType {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'title': json['title'] == null ? undefined : json['title'],
        'longTitle': json['longTitle'] == null ? undefined : json['longTitle'],
        'description': json['description'] == null ? undefined : json['description'],
        'view': json['view'] == null ? undefined : json['view'],
        'index': json['index'] == null ? undefined : json['index'],
    };
}

export function VariantTypeToJSON(value?: VariantType | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'title': value['title'],
        'longTitle': value['longTitle'],
        'description': value['description'],
        'view': value['view'],
        'index': value['index'],
    };
}

